var i = Object.defineProperty, f = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var p = (r, o, t) => o in r ? i(r, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[o] = t, a = (r, o) => {
  for (var t in o || (o = {}))
    c.call(o, t) && p(r, t, o[t]);
  if (e)
    for (var t of e(o))
      s.call(o, t) && p(r, t, o[t]);
  return r;
}, m = (r, o) => f(r, n(o));
import g, { forwardRef as h } from "react";
import d from "../lib/IconBase.mjs";
import l from "../defs/ShoppingCart.mjs";
const w = h((r, o) => /* @__PURE__ */ g.createElement(d, m(a({ ref: o }, r), { weights: l })));
w.displayName = "ShoppingCart";
export {
  w as ShoppingCart
};
